import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
    hrRecommendPostInfo: (data) => http.post(`${hr}/HrRecommend/PostInfo`, data), // 内推用户端-投递：岗位信息
    uuid: (data) => http.post(`${hr}/interview/getuuid`, data), // 获取uuid
    sendResumeSelf: (data) => http.post(`${hr}/interview/sendResumeSelf`, data), // 投递简历（内部竞聘）
    // sendResumeFileSelf: (data) => http.post(`${hr}/interview/sendResumeFileSelf`, data), // 投递简历（内部竞聘）
    sendResumeOther: (data) => http.post(`${hr}/interview/sendResumeOther`, data), // 投递简历（推荐他人）
    selectResumeListHis: (data) => http.post(`${hr}/interview/selectResumeListHis`, data), // 历史投递
    selectResumeSelfDetail: (data) => http.post(`${hr}/interview/selectResumeSelfDetail`, data), // 历史投递 (自荐详情，内推详情)
    selectUserPositionDetail: (data) => http.post(`${hr}/interview/selectUserPositionDetail`, data), // 历史投递 (自荐详情，内推详情)
    bulletinBoard: (data) => http.post(`${hr}/HrRecommend/bulletinBoard`, data), // (内推/自荐看板)
    postInfo_next: (data) => http.post(`${hr}/HrRecommend/PostInfo_next`, data), // (投递：岗位信息)
    bulletinMap: (data) => http.post(`${hr}/HrRecommend/bulletinMap`, data), // (内推/自荐看板柱状图)
    deleteFileById: (data) => http.post(`${hr}/interview/deleteFileById`, data), // 删除简历
    queryHistorySuggest: (data) => http.post(`${hr}/HrRecommend/queryHistorySuggest`, data), // 历史推荐
    queryDetails: (data) => http.post(`${hr}/HrRecommend/queryDetails`, data), // (投递：岗位信息)
};
